export default "__VITE_ASSET__D_cKWPE3__"